import * as React from "react";
const SvgMicrophoneRounded = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.3333 7.33333V8.66667C11.3333 10.5076 9.84095 12 8 12C6.15905 12 4.66667 10.5076 4.66667 8.66667V7.33333M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM8 10C7.26362 10 6.66667 9.40305 6.66667 8.66667V5.33333C6.66667 4.59695 7.26362 4 8 4C8.73638 4 9.33333 4.59695 9.33333 5.33333V8.66667C9.33333 9.40305 8.73638 10 8 10Z",
      stroke: "currentColor",
      strokeWidth: 1.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgMicrophoneRounded;
